export const setRootColorPalette = (styles) => {
  Object.keys(styles).forEach((key) => {
    const cssVarName = key.replace('@', '--')
    document.documentElement.style.setProperty(cssVarName, styles[key])
  })
}
